const ContentTypes = {
    MODULAR: 'modular',
    STANDARD: 'standard',
    SHORT: 'short'
};

export default ContentTypes;